export default __webpack_public_path__ + "static/media/image-1.9340ddd0.jpg";